import { Reveal } from "@/components/Reveal";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { FAQ } from "@/data/site";

export default function FaqSection({ items = FAQ }) {
  return (
    <section id="faq" className="bg-neutral-100 py-24 md:py-32" data-testid="faq">
      <div className="mx-auto max-w-4xl px-5 md:px-8">
        <Reveal className="mb-12 text-center">
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-brand-red">Dúvidas Frequentes</p>
          <h2 className="mt-4 font-display text-4xl uppercase leading-[0.95] tracking-tight text-brand-obsidian md:text-6xl">
            Perguntas frequentes
          </h2>
        </Reveal>

        <Reveal>
          <Accordion type="single" collapsible className="w-full">
            {items.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-black/10">
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="py-5 text-left font-heading text-base font-medium uppercase tracking-wide text-brand-obsidian hover:no-underline hover:text-brand-red md:text-lg"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm leading-relaxed text-neutral-600">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
